import React, { useState } from "react";
import * as RB from "react-bootstrap";
import Layout from "../Layout";
import OnReChallan from "../Components/Finish Goods/OnReChallan";
import List from "../Components/Finish Goods/List";
function FinishGoodsTabs() {
  const [activeTab, setActiveTab] = useState("finishGoods");

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Finished Goods</h1>
          </div>
          <div className="section-body">
            <RB.Card className="card shadow">
              <RB.Card.Body>
                <RB.Tabs
                  activeKey={activeTab}
                  onSelect={(tab) => setActiveTab(tab)}
                >
                  <RB.Tab eventKey="finishGoods" title="Finished Goods">
                    <List activeTab={activeTab} />
                  </RB.Tab>

                  <RB.Tab eventKey="onReChallan" title="On Pre-Challan">
                    <OnReChallan activeTab={activeTab}/>
                  </RB.Tab>
                </RB.Tabs>
              </RB.Card.Body>
            </RB.Card>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default FinishGoodsTabs;
